import type { IconSvgObject } from './types';

const WebflowIcon: IconSvgObject = [
  ["path", { d: "M15.6183 18L22 6H16L14 10L13.5 6H9.62417C8.62417 9 6.5 13.5 2 13.5V18C6.5 18 13 12.5 13 12.5L10 18H15.6183Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 6V10.5H6.5V6H2Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default WebflowIcon;
